import { NgStyle } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faX } from '@fortawesome/free-solid-svg-icons'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { DataMap } from '@grapecity/wijmo.grid'
import imageCompression, { Options } from 'browser-image-compression'
import { fromMapToList } from 'src/app/shared/shared-functions'

import { ListItem, Rental, RepositoryModal, TimeUnit, TimeUnitEx } from '../../shared'

@Component({
    templateUrl: './rental.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent, NgStyle],
})
export class RentalComponent extends RepositoryModal<Rental> implements OnInit {
    faX = faX
    jobMap: ListItem<string>[] = []
    vendorMap: ListItem<number>[] = []
    userList: ListItem<number>[] = []
    maintMap: ListItem<boolean>[] = [new ListItem(true, 'Rental Company'), new ListItem(false, 'VanCon')]
    fuelTypeMap: ListItem<string>[] = [new ListItem('D', 'Diesel'), new ListItem('O', 'Off-Road'), new ListItem('G', 'Gas')]
    billingCycleMap: ListItem<number>[] = [
        new ListItem(TimeUnit.Day, TimeUnitEx.toDisplayAdverb(TimeUnit.Day)),
        new ListItem(TimeUnit.Week, TimeUnitEx.toDisplayWithUnit(TimeUnit.Week)),
        new ListItem(TimeUnit.TwoWeek, TimeUnitEx.toDisplayWithUnit(TimeUnit.TwoWeek)),
        new ListItem(TimeUnit.Month, TimeUnitEx.toDisplayWithUnit(TimeUnit.Month)),
        new ListItem(TimeUnit.OverMonth, TimeUnitEx.toDisplayWithUnit(TimeUnit.OverMonth)),
    ]
    rateUnitMap: ListItem<number>[] = [
        new ListItem(TimeUnit.Hour, TimeUnitEx.toDisplayAdverb(TimeUnit.Hour)),
        new ListItem(TimeUnit.Day, TimeUnitEx.toDisplayAdverb(TimeUnit.Day)),
        new ListItem(TimeUnit.Week, TimeUnitEx.toDisplayAdverb(TimeUnit.Week)),
        new ListItem(TimeUnit.Month, TimeUnitEx.toDisplayAdverb(TimeUnit.Month)),
    ]
    boolMap: ListItem<boolean>[] = [new ListItem(true, 'Yes'), new ListItem(false, 'No')]
    images: any[] = []
    progress = 0

    ngOnInit() {
        if (this.isAdding) {
            this.target.isRpo = false
            this.target.billingCycle = TimeUnit.Month
            this.target.rateUnit = TimeUnit.Hour
            this.target.fuelType = 'D'
            this.target.vendorMaintains = true
        }
        this.jobMap = this.services.data.vpJobs.items.map(x => new ListItem(x.id, x.id + ' ' + x.name))
        this.vendorMap = this.services.data.vendors.items.map(x => new ListItem(x.id, x.name))

        // TODO: Filter the rentedBy and pickedUpBy by position codes.
        const dm = this.editOptions.initializeParams.activeUserMap as DataMap
        this.userList = fromMapToList(dm, 'id', 'name')
    }

    calculateReturnDate() {
        if (!this.target.scheduledReturnDate && this.target.pickedUpDate) {
            let days = 0
            switch (this.target.billingCycle) {
                case TimeUnit.Day:
                    days = 1
                    break
                case TimeUnit.Week:
                    days = 7
                    break
                case TimeUnit.TwoWeek:
                    days = 14
                    break
                case TimeUnit.OverMonth:
                case TimeUnit.Month:
                    days = 28
                    break
            }
            const date = new Date(this.target.pickedUpDate)
            date.setDate(date.getDate() + days)
            this.target.scheduledReturnDate = date
        }
    }

    removeImage(image) {
        this.images.remove(image)
    }

    async onFileChanged(event) {
        // When the user picks images, we will compress and store them locally.
        // They will get uploaded after the item is saved.
        const files = event.target.files
        const progress = (p: number) => {
            this.progress = p
        }
        for (const file of files) {
            const options: Options = {
                maxSizeMB: 2,
                maxWidthOrHeight: 1920,
                useWebWorker: true,
                onProgress: progress,
            }
            const compressedFile = await imageCompression(file, options)
            compressedFile['url'] = await imageCompression.getDataUrlFromFile(compressedFile)
            this.images.push(compressedFile)
        }
    }

    protected onBeforeSave(): boolean {
        if (!this.target.scheduledReturnDate) {
            this.services.notification.error('Scheduled Return Date is required.')
            return false
        }
        return true
    }

    protected onSave(resolveSave: (result?: any) => void, rejectSave: (reason?: any) => void) {
        const observable = this.isAdding || this.isDuplicating ? this.repositoryAdd() : this.repositoryEdit()
        observable.subscribe({
            next: successResult => {
                if (this.images.length === 0) {
                    resolveSave(successResult)
                    return
                }

                //If the saving of the record is successfult, we will upload any images.
                const uploadData = new FormData()
                uploadData.append('id', successResult.id)
                for (let i = 0; i < this.images.length; i++) {
                    uploadData.append('myFile' + i, this.images[i], this.images[i].name)
                }
                this.services.data.post('api/Rental/UploadImages', uploadData).subscribe({
                    next: () => {
                        resolveSave(successResult)
                    },
                    error: errorResult => {
                        rejectSave(errorResult)
                    },
                })
            },
            error: errorResult => {
                rejectSave(errorResult)
            },
        })
    }
}
